angular
  .module 'bookAndPay'
  .controller 'ShowEventsCtrl', (
    $scope,
    $state,
    $window,
    DataService,
    cart,
    events
  ) ->
    $scope.cart = cart
    $scope.events = if events.plain then events.plain() else events
    $scope.currency = DataService.currency

    $scope.chooseEvent = (event) ->
      $scope.isLoading = true
      $scope.cart.event_id = event.id
      $scope.cart.save().then (response) ->
        $scope.isLoading = false
        $state.go 'bookAndPay.editCart', uuid: $scope.cart.cart_uuid
      , (response) ->
        $scope.errors = response.data.errors
        $scope.isLoading = false
        $window.scrollTo(0, 0)

    $scope.displayTime = (event) ->
      start = moment(event.start, 'YYYY/MM/DD HH:mm').format('ddd, D MMM [at] h:mm')
      end = moment(event.end, 'YYYY/MM/DD HH:mm').format('h:mma')
      "#{start}-#{end}"

    $scope.cancelBooking = ->
      if $window.confirm "Are you sure you want to cancel your booking?"
        $state.go 'bookAndPay.newCart', uuid: cart.membership_plan_uuid
